import React from "react";
import { Link } from "react-router-dom"; // 1. Import Link

const brands = [
  "Hertz",
  "Avis",
  "Budget",
  "Alamo",
  "Dollar",
  "Thrifty",
  "Sixt",
  "Enterprise",
];

export default function PopularBrands() {
  return (
    <div className="mx-auto max-w-[1580px] p-4 md:p-8">
      <div className="rounded-xl border border-slate-200 bg-[#fbfcfd] p-5 sm:p-6 shadow-sm">
        {/* Header Section */}
        <div className="mb-6 flex items-center gap-4">
          {/* Dark Blue Car Icon Box */}
          <div className="flex h-[46px] w-[46px] flex-shrink-0 items-center justify-center rounded-[10px] bg-[#081c3a] text-white shadow-sm">
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 16H9m10 0h3v-3.15a1 1 0 00-.84-.99L16 11l-2.7-3.6a2 2 0 00-1.6-.8H7.3a2 2 0 00-1.6.8L3 11l-1.16.86a1 1 0 00-.84.99V16h3m10 0a2 2 0 11-4 0 2 2 0 014 0zM9 16a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>

          <div>
            <h2 className="text-[19px] font-extrabold text-[#081c3a] leading-tight">
              Popular Rental Brands
            </h2>
            <p className="text-[14px] font-medium text-[#4b6a97] mt-0.5">
              Quick brand rental option pages
            </p>
          </div>
        </div>

        {/* Brands Grid - Highly adaptive from mobile to desktop */}
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7">
          {brands.map((brand) => (
            <Link
              key={brand}
              to={`/car-rental-brands/${brand.toLowerCase()}`}
              className="flex items-center justify-center rounded-lg border border-slate-200 bg-white px-4 py-[14px] transition-all hover:border-[#081c3a] hover:bg-slate-50 hover:shadow-sm"
            >
              <span className="font-extrabold text-[#081c3a] text-center">
                {brand}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
